import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import { Link } from "react-router-dom";
import editImg from "../images/edit.png"
import { database } from '../firebase';
export default class Report extends Component {
    constructor(props) {
        super(props)
        this.state = {
            reportData: [],
        }
    }
    componentDidMount() {
        this.renderList();
    }
    async renderList() {
        let dataList = []
        await database.ref("Guidance").once('value', function (snapshot) {
            snapshot.forEach(
                function (ChildSnapshot) {

                    if (ChildSnapshot.val().hasOwnProperty('userDate')) {
                        if (ChildSnapshot.val().userDate.role === "User") {
                            dataList.push({
                                key: ChildSnapshot.key,
                                userData: ChildSnapshot.val().userDate,
                                Expertise: ChildSnapshot.val().Expertise,
                                Experience: ChildSnapshot.val().Experience,
                                CreatedAt: ChildSnapshot.val().createdAt,
                            })
                        }
                    }
                }
            )
        })
        this.setState({
            reportData: dataList
        })
    }

    render() {
        return (
            <div className="main-wrapper">
                <Header></Header>
                <div className="main-content">
                    <Menu></Menu>
                    <div className="content-right-wrapper">
                        <div className="container">
                            <div className='form-wrapper'>
                                <ul className="breadcrumb">
                                    <li><a href="/dashboard">Dashboard</a></li>
                                    <li>Report</li>
                                </ul>
                                <div className='form-head'>
                                    User Details
                                </div>
                                <div className='table'>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col">Name</th>
                                                <th scope="col">Email Id</th>
                                                <th scope="col">Phone</th>
                                                <th scope="col">Expertise</th>
                                                <th scope="col">Experience</th>
                                                <th scope="col">Created On</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {this.state.reportData.map((data, i) => {
                                                return (
                                                    <tr>
                                                        <th scope="row">{data.userData.fullName}</th>
                                                        <td>{data.userData.emailId}</td>
                                                        <td>{data.userData.phoneno}</td>
                                                        <td>{data.Expertise}</td>
                                                        <td>{data.Experience}</td>
                                                        <td>{data.CreatedAt}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/admin/userReport.jsx